<template>
  <div class="overlay center">
    <div class="modal reset" v-click-outside="outside">
      <figure class="center">
        <img src="@/assets/img/reset.svg" alt="" />
      </figure>
      <p>Restart Simulation?</p>
      <span
        >The game will start over. <br />All your progress will be lost.</span
      >

      <div class="buttons">
        <div class="button ghost" @click="$emit('close')">Cancel</div>
        <div class="button" @click="restart">Restart</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reset",
  props: {},
  emits: ["close"],
  data() {
    return {
      opened: false,
    };
  },

  computed: {
    dayLength: function() {
      return (
        this.$store.state.intervalTime / this.$store.state.timeMulti / 1000
      );
    },

    prodLength: function() {
      return 1 / this.$store.state.timeMulti;
    },
  },

  mounted: function() {
    setTimeout(() => {
      this.opened = true;
    }, 100);
  },
  unmounted: function() {
    this.opened = false;
  },

  methods: {
    outside: function() {
      if (this.opened) {
        this.$emit("close");
      }
    },
    restart: function() {
      this.$store.commit("addMoney", -this.$store.state.money);
      this.$emit("close");
      this.$store.commit("setFinals", new Date());

      this.track("RESTART", "RESTART");
      setTimeout(() => {
        this.$store.commit("resetGame");
        this.$store.dispatch("loadProdItem", 0);
        this.$store.dispatch("loadProdItem", 1);
      }, 1);

      setTimeout(() => {
        window.location.reload();
      }, 2);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.overlay {
  position: fixed;
  z-index: 9999;
  .modal {
    border-radius: 12px;
    padding: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    min-width: 300px;

    p {
      font-weight: 600;
      color: $black;
    }

    .ghost {
      color: $black;
    }

    input {
      font-size: 24px;
      text-align: center;
      max-width: 120px;
      border-radius: 6px;
      margin-bottom: 24px;
    }

    .button {
      width: 100%;
      margin: 8px;
    }
  }

  .reset {
    figure {
      width: 72px;
      height: 72px;
      border-radius: 72px;
      background: $red;

      img {
        width: 24px;
        height: 24px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
